// Preview slots ("planets"), mirroring testCustomDomains in .pipelines/bicep/WebApp.bicep.
// They read the same Sanity dataset as test.naf.no, so absolute links authored there
// point at test.naf.no. Treating that host as our own keeps the visitor on the planet.
const PREVIEW_HOSTS = [
  'mercury.naf.no',
  'venus.naf.no',
  'earth.naf.no',
  'mars.naf.no',
  'jupiter.naf.no',
  'saturn.naf.no',
  'uranus.naf.no',
  'neptune.naf.no',
];

const PREVIEW_CONTENT_HOST = 'test.naf.no';

/** Whether `hostname` should be handled as the site served at `siteHostname`. */
export const isSameSiteHost = (siteHostname: string, hostname: string): boolean => {
  if (hostname === siteHostname) return true;
  return PREVIEW_HOSTS.includes(siteHostname) && hostname === PREVIEW_CONTENT_HOST;
};

/**
 * Points an absolute URL on a host aliased to the current site (e.g. test.naf.no on a planet)
 * at the current origin instead. Other URLs are returned untouched. Browser only.
 */
export const toCurrentSiteUrl = (url: string): string => {
  if (!/^https?:\/\//i.test(url)) return url;
  try {
    const target = new URL(url);
    const { hostname, origin } = window.location;
    if (target.hostname !== hostname && isSameSiteHost(hostname, target.hostname)) {
      return `${origin}${target.pathname}${target.search}${target.hash}`;
    }
  } catch {
    // Fall through with the untouched URL.
  }
  return url;
};
